/*
 *
 * PackageLoading constants
 *
 */

export const DEFAULT_ACTION = 'app/Press/DEFAULT_ACTION';
export const LOAD_PRESS_ORDER = 'app/Press/LOAD_PRESS_ORDER';
export const PRESS_ORDER_LOADED = 'app/Press/PRESS_ORDER_LOADED';
